<template>
  <div class="panel mt-20">
    <div class="header">
      <h2>动态</h2>
    </div>
    <div class="flex-row-between">
      <el-radio-group
        size="mini"
        v-model="logRequest.sort"
        @change="requestCustomerLogList"
        style="width: 160px"
      >
        <el-radio-button :label="0">正序</el-radio-button>
        <el-radio-button :label="1">倒序</el-radio-button>
      </el-radio-group>
      <el-select
        size="mini"
        v-model="logRequest.type"
        placeholder="动态类型"
        style="flex: 1; max-width: 160px"
        @change="requestCustomerLogList"
      >
        <el-option
          v-for="item in logTypes"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
    </div>
    <div class="mt-20">
      <!-- <el-timeline style="font-size:12px">
        <el-timeline-item
          v-for="log in logs"
          :key="log.id"
          :timestamp="formatTime(log.created_at, 'YYYY年M月D日 HH:mm')"
        >
          <div>
            <h4 class="flex-row-between">
              <span class="flex:1">
                {{ log.title }}
                <template v-for="link in log.links">
                  <el-tag
                    type="info"
                    class="log-tag"
                    v-if="link.url.length == 0"
                    size="mini"
                  >
                    <span class="el-icon-money"></span>
                    ￥{{ link.text }}
                  </el-tag>
                  <router-link class="log-tag" v-else :to="link.url">
                    <el-tag size="mini">{{ link.text }}</el-tag>
                  </router-link>
                </template>
              </span>
              <span class="info" style="width:60px;text-align:right">
                <span class="text-primary">{{ log.user.name }}</span>
              </span>
            </h4>
            <div>{{ log.content }}</div>
            <div
              v-if="
                log.type == 12 ||
                  log.type == 11 ||
                  log.type == 14 ||
                  log.type == 6
              "
            >
              <p v-for="(v, k) in log.params">{{ logParams(k, v) }}</p>
            </div>
          </div>
        </el-timeline-item>
      </el-timeline> -->
    </div>
    <el-table v-if="!isMobile()" :data="logs" style="width: 100%" key="logs">
      <el-table-column label="类型" width="100">
        <template slot-scope="scope">
          <div>{{ scope.row.title }}</div>
        </template></el-table-column
      >
      <el-table-column label="内容">
        <template slot-scope="scope">
          <template v-for="link in scope.row.links">
            <el-tag
              type="info"
              class="log-tag"
              v-if="link.url.length == 0"
              size="mini"
            >
              <span class="el-icon-money"></span>
              ￥{{ link.text }}
            </el-tag>
            <router-link class="log-tag" v-else :to="link.url">
              <el-tag size="mini">{{ link.text }}</el-tag>
            </router-link>
          </template>
          <div>{{ scope.row.content }}</div>
          <div
            v-if="
              scope.row.type == 12 ||
              scope.row.type == 11 ||
              scope.row.type == 14 ||
              scope.row.type == 6
            "
          >
            <div v-for="(v, k) in scope.row.params">{{ logParams(k, v) }}</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="user.name"
        label="操作人"
        width="120"
        align="center"
      >
      </el-table-column>
      <el-table-column label="操作时间" width="160" align="right">
        <template slot-scope="scope">
          <span>{{
            formatTime(scope.row.created_at, 'YYYY-MM-DD HH:mm')
          }}</span>
        </template>
      </el-table-column>
    </el-table>
    <ul v-else class="list-style">
      <li v-for="item in logs" class="font-12">
        <div class="flex-row-between">
          <span>{{ item.title }}</span>
          <span class="text-gray">{{
            formatTime(item.created_at, 'YYYY-MM-DD HH:mm')
          }}</span>
        </div>
        <div>
          <template v-for="link in item.links">
            <el-tag
              type="info"
              class="log-tag"
              v-if="link.url.length == 0"
              size="mini"
            >
              <span class="el-icon-money"></span>
              ￥{{ link.text }}
            </el-tag>
            <router-link class="log-tag" v-else :to="link.url">
              <el-tag size="mini">{{ link.text }}</el-tag>
            </router-link>
          </template>
          <div>{{ item.content }}</div>
          <div
            v-if="
              item.type == 12 ||
              item.type == 11 ||
              item.type == 14 ||
              item.type == 6
            "
          >
            <div v-for="(v, k) in item.params">{{ logParams(k, v) }}</div>
          </div>
        </div>
      </li>
    </ul>
    <div v-if="logTotal > logRequest.size" class="mt-20">
      <el-pagination
        small
        :page-size="logRequest.size"
        :current-page.sync="logRequest.page"
        layout="total, prev, pager, next"
        :total="logTotal"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { customerLogList } from '@/service/getData.js'
import { CustomerLogMap, CutomerLogTypes } from '@/config/global'
import { formatTime } from '@/util/index'
import { CodeToText } from '@/util/area_tool'
import { isMobile } from '../../util'

export default {
  props: {
    customerID: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {
      isMobile,
      formatTime,
      CustomerLogMap,
      logRequest: {
        type: 0,
        sort: 0,
        page: 1,
        size: 10,
      },
      logs: [],
      CodeToText,
      logTotal: 0,
      logTypes: CutomerLogTypes,
    }
  },
  watch: {
    'logRequest.page': function () {
      this.requestCustomerLogList()
    },
  },
  created() {
    this.requestCustomerLogList()
  },
  methods: {
    async requestCustomerLogList() {
      let data = {
        page: this.logRequest.page - 1,
        size: this.logRequest.size,
        sort: this.logRequest.sort,
        type: this.logRequest.type,
        customer_id: this.customerID,
      }
      let res = await customerLogList(data)
      this.logTotal = res.data.total
      this.logs = res.data.list.map((log) => {
        log.title = CustomerLogMap[log.type]
        var links = []
        if (log.links.length > 0) {
          let array = log.links.split(';')
          links = array.map((item) => {
            return this.logLink(item)
          })
        }
        log.links = links
        return log
      })
    },
    logLink(lnk) {
      let links = lnk.split('|')
      let text = links[0]
      let linkInfo = links[1]
      let infos = linkInfo.split(':')
      let url = ''
      if (infos[0] == 'quotation') {
        url = '/dashboard/quotations/' + infos[1]
      } else if (infos[0] == 'amount') {
        url = ''
      } else if (infos[0] == 'order') {
        url = '/dashboard/dealer/orders/' + infos[1]
      }
      return {
        text: text,
        url: url,
      }
    },
    logParams(k, v) {
      let v1,
        v2 = ''
      if (v.length > 0) {
        v1 = v[0]
      }
      if (v.length > 1) {
        v2 = v[1]
      }
      if (k == '省' || k == '市' || k == '区/县') {
        v1 = this.CodeToText[v1]
        v2 = this.CodeToText[v2]
      } else if (k.indexOf('时间') != -1) {
        v1 = formatTime(v1)
        v2 = formatTime(v2)
      } else if (k.indexOf('SAP') != -1) {
        v1 = v1 == 1 ? '已同步' : '未同步'
        v2 = v2 == 1 ? '已同步' : '未同步'
      } else if (k.indexOf('铭牌照片') != -1) {
        return ''
      } else if (k.indexOf('直销客户') != -1) {
        v1 = v1 == 1 ? '是' : '否'
        v2 = v2 == 1 ? '是' : '否'
      } else if (k.indexOf('重点客户') != -1) {
        v1 = v1 == 2 ? '是' : '否'
        v2 = v2 == 2 ? '是' : '否'
      } else if (k.indexOf('特别关注') != -1) {
        k = '直销客户'
        v1 = v1 == 1 ? '是' : '否'
        v2 = v2 == 1 ? '是' : '否'
      }
      return k + '：' + v1 + ' -> ' + v2
    },
  },
}
</script>